export default class ProfileCountryModel {
    public id: string = null;
    public name: string = null;
    public assets: {} = null;
}